import * as React from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { SupportIcon } from "affinityIcons";

import { NavBar } from "affinityUI/structures/layout/navBar";
import { pageNotFound } from "lib/errorHandler";
import { Page } from "lib/page";

import { SupportIndex } from "../support/index";

import { RecoverPasswordSuccess } from "./recoverPassword/recoverPasswordSuccess";
import { SetPasswordSuccess } from "./setPassword/setPasswordSuccess";
import { LoginPage } from "./login";
import { RecoverPasswordPage } from "./recoverPassword";
import { SetPasswordPage } from "./setPassword";

export const LoginIndex: React.FC = () => {
  return (
    <>
      <NavBar>
        <NavLink to="support">
          <NavBar.Item>
            <SupportIcon />
            Support
          </NavBar.Item>
        </NavLink>
      </NavBar>
      <Routes>
        {pageNotFound}
        <Route index element={<LoginPage />} />
        <Route path="support/*" element={<SupportIndex />} />
        <Route path="set-password">
          <Route index element={<Page element={<SetPasswordPage />} />} />
          <Route path="success" element={<SetPasswordSuccess />} />
        </Route>
        <Route path="recover">
          <Route index element={<Page element={<RecoverPasswordPage />} />} />
          <Route path="success" element={<RecoverPasswordSuccess />} />
        </Route>
      </Routes>
    </>
  );
};
